import { $stateParams } from '../../../../router';

export const ChatUserNameService = {
    storageKey: () => `gecko-username-${$stateParams.contact_uuid}`,

    storedName: () => window.localStorage.getItem(`gecko-username-${$stateParams.contact_uuid}`),
};

export default ChatUserNameService;